import type { PaymentPoliciesStore } from './interfaces'
import type { TutorCategoryType } from '@app/types/tutors/enums'

export const actions = {
  setPaginatedData (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['paginatedData']): void {
    this.paginatedData = payload
  },
  setSelectedDemoEla (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['selectedDemoEla']): void {
    this.selectedDemoEla = payload
  },
  setSelectedDemoMath (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['selectedDemoMath']): void {
    this.selectedDemoMath = payload
  },
  setSelectedPaidEla (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['selectedPaidEla']): void {
    this.selectedPaidEla = payload
  },
  setSelectedPaidMath (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['selectedPaidMath']): void {
    this.selectedPaidMath = payload
  },
  setModalConfirmPaymentPolicy (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['isModalConfirmPaymentPolicy']): void {
    this.isModalConfirmPaymentPolicy = payload
  },
  setEdits (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['edits']): void {
    this.edits = payload
  },
  setTutorPaymentPolicies (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['tutorPaymentPoliciesData']): void {
    this.tutorPaymentPoliciesData = payload
  },
  setSelectedName (this: PaymentPoliciesStore, category: TutorCategoryType, name: string): void {
    this.selectedNames[category] = name
  },
  setLoading (this: PaymentPoliciesStore, payload: PaymentPoliciesStore['loading']): void {
    this.loading = payload
  },
}
